<template>
    <v-flex xs12 sm12 d-block class="card-dados">
        <h3 class="card-dados__titulo">Dados da Compra Direta</h3>
        <v-layout wrap align-center white>
            <v-flex xs12 sm3 d-flex>
                <div id="numeroCompraDireta" class="az-text">
                    <label>Nº Compra Direta</label>
                    <p>
                        {{value.numero ? `${value.numero}/${value.ano}` : '--'}}
                    </p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="amparoLegal" class="az-text">
                    <label>Amparo Legal</label>
                    <p>{{value.amparoLegal ? value.amparoLegal.lei : '--'}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="tipo" class="az-text">
                    <label>Tipo</label>
                    <p>{{value.tipo | cdEnum(tiposCompraDireta)}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm2 d-flex v-if="value.processo !== 'SEPLAG-PRO-2025/23595'">
                <div class="az-text">
                    <label>Critério de Julgamento</label>
                    <p>{{criterioJulgamentoDaCompra}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="dataHoraAbertura" class="az-text">
                    <label>Data/Hora de Criação</label>
                    <p>{{value.dataHoraAbertura | az-date(humanizarFormatoDataHora(value.dataHoraAbertura))}}</p>
                </div>
            </v-flex>

          <v-flex v-if="!ehCompraPropostaManualEhAtiva" xs12 sm3 d-flex>
          <div id="dataHoraInicioEnvioPropostas" class="az-text">
            <label>Data/Hora Inicio Envio Propostas</label>
            <p>{{value.dataHoraInicioEnvioPropostas | az-date(humanizarFormatoDataHora(value.dataHoraInicioEnvioPropostas))}}</p>
          </div>
          </v-flex>

            <v-flex v-if="!ehCompraPropostaManualEhAtiva" xs12 sm3 d-flex>
                <div v-if="exibirFimEnvioPropostasELances" id="dataHoraFimEnvioPropostas" class="az-text">
                    <label>Data/Hora Fim Envio Propostas</label>
                    <p>{{value.dataHoraFimEnvioPropostas | az-date(humanizarFormatoDataHora(value.dataHoraFimEnvioPropostas))}}</p>
                </div>
                <div v-else id="dataHoraEncerramento" class="az-text">
                    <label>Data/Hora de Encerramento</label>
                    <p>{{value.dataHoraEncerramento | az-date(humanizarFormatoDataHora(value.dataHoraEncerramento))}}</p>
                </div>
            </v-flex>
            <v-flex v-if="exibirFimEnvioPropostasELances && value.tipo === 'COM_DISPUTA'" xs12 sm3 d-flex>
                <div id="duracaoEtapaDeLances" class="az-text">
                    <label>Duração Etapa de Lances</label>
                    <p>{{value.duracaoEtapaLances ? value.duracaoEtapaLances : '--'}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex v-if="deveMostrarTempoRandomico">
                <div class="az-text">
                    <label>Tempo Randômico</label>
                    <p>{{tempoRandomicoLance ? 'De 1 a ' + tempoRandomicoLance + ' minutos' : '--'}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="contato" class="az-text">
                    <label>Contato</label>
                    <p>{{value.nomeContato ? value.nomeContato : '--'}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="telefone" class="az-text">
                    <label>Telefone</label>
                    <p>{{value.telefoneContato | az-phone}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="prazoEntrega" class="az-text">
                    <label>Prazo de Entrega</label>
                    <p>{{value.prazoEntregaDescritivo ? `${value.prazoEntregaDescritivo}` : '--'}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="localEntrega" class="az-text">
                    <label>Local de Entrega</label>
                    <p>{{value.localEntrega ? value.localEntrega : '--'}}</p>
                </div>
            </v-flex>
            <v-flex v-if="ehLei14_133(value.amparoLegal)" xs12 sm3 d-flex>
                <div id="possuiValorReferencia" class="az-text">
                    <label>Dispensa sem Valor Estimado</label>
                    <p>{{value.possuiValorReferencia ? 'Não' : 'Sim' }}</p>
                </div>
            </v-flex>
            <v-flex v-if="value.possuiValorReferencia || !ehLei14_133(value.amparoLegal)" xs12 sm3 d-flex>
                <div id="valorReferencia" class="az-text">
                    <label>Exibir Valor de Referência</label>
                    <p>{{value.exibeValorReferencia ? 'Sim' : 'Não' }}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex v-if="value.tipo === 'COM_DISPUTA' && value.processo !== 'SEPLAG-PRO-2025/23595'">
                <div id="disputaPor" class="az-text">
                    <label>Disputa por</label>
                    <p>{{value.disputaPor | cdEnum(disputasCompraDireta)}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="casasDecimais" class="az-text">
                    <label>Casas Decimais</label>
                    <p>{{value.casasDecimais ? value.casasDecimais : '--'}}</p>
                </div>
            </v-flex>
          <v-flex xs12 sm3 d-flex>
            <div id="criterio" class="az-text">
              <label>Critério Redução</label>
              <p>{{value.criterioReducaoCasasDecimais | azEnum(criteriosReducaoCasasDecimais)}}</p>
            </div>
          </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="criadoPor" class="az-text">
                    <label>Criado por</label>
                    <p>{{value.criadoPor ? value.criadoPor : '--'}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex>
                <div id="situacao" class="az-text">
                    <label>Situação</label>
                    <p>{{value.situacao | azEnum(situacoesCompraDireta)}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm12 d-flex>
                <div id="obs" class="az-text">
                    <label>Observação</label>
                    <p style="white-space: pre-line;">{{value.observacao ? value.observacao : '--'}}</p>
                </div>
            </v-flex>
        </v-layout>
        <v-layout v-if="value.permitirEdicaoRecursoFederal" wrap align-center white class="edicaoRecursoFederal">
            <v-flex xs12 sm3 d-flex id="recurso-federal">
                <div class="az-text">
                    <label>Recurso Federal</label>
                    <p>{{value.recursoFederal ? "Sim" : "Não"}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="value.recursoFederal" id="tipo-transferencia">
                <div class="az-text">
                    <label>Tipo Transferência</label>
                    <p>{{value.tipoTransferencia | azEnum(tiposTransferencia)}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="n-convenio">
                <div class="az-text">
                    <label>Nº Convênio</label>
                    <p>{{value.numeroConvenio ? value.numeroConvenio : '--'}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="ano-instrumento">
                <div class="az-text">
                    <label>Ano Instrumento</label>
                    <p>{{value.anoInstrumento ? value.anoInstrumento : '--'}}</p>
                </div>
            </v-flex>
            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="legislacao">
                <v-select name="Legislação" label="Legislação" placeholder="Selecione"
                          key="Legislação"
                          :menu-props="{ top: false, offsetY: true }"
                          v-model="value.legislacao" class="required-field" v-validate="'required'"
                          :items="value.legislacoes.map(({id, codigo, codigoIntegracao}) => ({key:codigoIntegracao, value:codigo}))"
                          item-text="value" item-value="key" :error-messages="errors.collect('Legislação')"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="tipo-objeto">
                <v-select name="Tipo Objeto" label="Tipo Objeto" placeholder="Selecione"
                          key="Tipo Objeto"
                          :menu-props="{ top: false, offsetY: true }"
                          v-model="value.tipoObjeto" class="required-field" v-validate="'required'"
                          :items="Object.entries(tiposObjeto).map(([key, value]) => ({key, value}))"
                          item-text="value" item-value="key" :error-messages="errors.collect('Tipo Objeto')"/>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="origem-recurso">
                <v-select name="Origem Recurso" label="Origem Recurso" placeholder="Selecione"
                          key="Origem Recurso"
                          :menu-props="{ top: false, offsetY: true }"
                          v-model="value.origemRecurso" class="required-field" v-validate="'required'"
                          :items="Object.entries(origensRecursoFederal).map(([key, value]) => ({key, value}))"
                          item-text="value" item-value="key" :error-messages="errors.collect('Origem Recurso')"/>
            </v-flex>
        </v-layout>
        <v-layout v-else wrap align-center white class="visualizacaoRecursoFederal">
            <v-flex xs12 sm3 d-flex id="recurso-federal">
                <div class="az-text">
                    <label>Recurso Federal</label>
                    <p>{{value.recursoFederal ? 'Sim' : 'Não'}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="value.recursoFederal" id="tipo-transferencia">
                <div class="az-text">
                    <label>Tipo Transferência</label>
                    <p>{{value.tipoTransferencia | azEnum(tiposTransferencia)}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="n-convenio">
                <div class="az-text">
                    <label>Nº Convênio</label>
                    <p>{{value.numeroConvenio ? value.numeroConvenio : '--'}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="ano-instrumento">
                <div class="az-text">
                    <label>Ano Instrumento</label>
                    <p>{{value.anoInstrumento ? value.anoInstrumento : '--'}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="legislacao">
                <div class="az-text">
                    <label>Legislação</label>
                    <p>{{value.legislacao ? value.legislacao : '--'}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="tipo-objeto">
                <div class="az-text">
                    <label>Tipo Objeto</label>
                    <p>{{value.tipoObjeto | azEnum(tiposObjeto)}}</p>
                </div>
            </v-flex>

            <v-flex xs12 sm3 d-flex v-if="transferenciaVoluntarios" id="origem-recurso">
                <div class="az-text">
                    <label>Origem Recurso</label>
                    <p>{{value.origemRecurso | azEnum(origensRecursoFederal)}}</p>
                </div>
            </v-flex>
        </v-layout>
        <v-layout wrap align-center white v-if="deveMostrarIntervaloDeLances">
            <v-flex xs12 sm2 d-flex ma-0>
                <div class="az-text">
                  <label>Diferença Mínima entre Lances</label>
                  <p>{{montarDiferencaEntreLances}}</p>
                </div>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>

import {disputasCompraDireta, opcaoSimNao, situacoesCompraDireta,
    tiposCompraDireta, criteriosReducaoCasasDecimais, tiposTransferencia,
    tiposObjeto, origensRecursoFederal, criteriosJulgamento,
    validacaoIntervaloLances} from '@/core/constants'

export default {
    name: 'PainelCompraDiretaVisualizacao',
    props: {
        value: {
            required: true
        },
        exibirFimEnvioPropostasELances: {
            type: Boolean,
            default: true
        },
        tempoRandomicoLance:{
            type: Number,
            default: null
        },
        ehCompraPropostaManualEhAtiva: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            disputasCompraDireta,
            opcaoSimNao,
            situacoesCompraDireta,
            tiposCompraDireta,
            criteriosReducaoCasasDecimais,
            tiposTransferencia,
            tiposObjeto,
            origensRecursoFederal,
            criteriosJulgamento,
            validacaoIntervaloLances,
            validacaoCriteriosJulgamentoTexto:''
        }
    },
    computed:{
        transferenciaVoluntarios(){
            return this.value.tipoTransferencia === 'VOLUNTARIAS'
        },
        montarDiferencaEntreLances(){
            if(!this.value.intervaloLances || !this.value.validarIntervaloLancesPor)
                return '--'

            const texto = this.validacaoIntervaloLances[this.value.validarIntervaloLancesPor].texto

            return texto ? `${texto} - ${this.value.intervaloLances}` : '--'
        },
        criterioJulgamentoDaCompra(){
            if(!this.value.criterioJulgamento) return '--'

            return this.criteriosJulgamento[this.value.criterioJulgamento].texto
        },
        deveMostrarIntervaloDeLances() {
            return (this.ehLei14_133(this.value.amparoLegal) || this.ehLei13_303(this.value.amparoLegal)) && (this.value.tipo && this.value.tipo === 'COM_DISPUTA')
        },
        deveMostrarTempoRandomico() {
            return ((this.value.tipo && this.value.tipo === 'COM_DISPUTA') && this.value.tempoRandomicoLancePreenchido)
        },
    }
}
</script>
